import { useState, useEffect } from 'react';
import pdfIcon from '../../assets/images/pdfIcons.svg';
import docIcon from '../../assets/images/docIcon.svg';
import firstine from '../../assets/icons/file-list.svg';
import user1 from '../../assets/icons/user.svg';
import stetho from '../../assets/icons/stethoscope.svg';
import first from '../../assets/icons/first-aid.svg';
import briefcase2 from '../../assets/icons/briefcase-2-line.svg';
import graduation from '../../assets/icons/graduation-cap-line.svg';
import suitcase from '../../assets/icons/suitcase-line.svg';
import firstKit from '../../assets/icons/first-aid-kit.svg';
import arrowgo from '../../assets/icons/arrowgo.svg';
import { useNavigate } from 'react-router-dom';
import { RatingBar, RatingQuestion, FeedbackModal } from '@specific';

const HospitalContractDetail = () => {
  const navigate = useNavigate();
  const [contractDetails, setContractDetails] = useState(null);
  const [isRatingOpen, setIsRatingOpen] = useState(false);
  const [showReviewsList, setShowReviewsList] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem('user'))
  );
  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('rowOriginalData'));
    console.log(savedData, '', 'savedData');
    setContractDetails(savedData);
  }, []);

  console.log('contractDetailscontractDetails', contractDetails);

  return (
    <>
      <RatingBar
        avg={contractDetails}
        setIsRatingOpen={setIsRatingOpen}
        setShowReviewsList={setShowReviewsList}
        name={contractDetails?.physician?.user?.firstName}
        contractEndDate={contractDetails?.end_date}
        contractDetails={contractDetails}
        check={true}
      />

      {userInfo.role === 'hospital_manager' && (
        <RatingQuestion
          isRatingOpen={isRatingOpen}
          setIsRatingOpen={setIsRatingOpen}
          contractId={contractDetails?._id}
          physicianId={contractDetails?.physician?._id}
          managerId={userInfo?.id}
        />
      )}

      <FeedbackModal
        showReviewsList={showReviewsList}
        setShowReviewsList={setShowReviewsList}
      />
      <div
        className="text-medium text-gray-500 rounded-lg w-full px-14 py-4"
        id="profile"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <div className="border-t border-l">
          <div className="bg-[#E2E4E9] h-[72px] items-center flex justify-between px-4">
            <div className="flex  space-x-1 items-center">
              <div className="">
                <img src={firstine} alt="License Icon" className="w-6 h-6 " />
              </div>
              <h3 className="label-medium pt-2">License Information</h3>
            </div>
            <button
              onClick={() => navigate(`/ContractDetail`)}
              type="submit"
              className="flex px-4 py-3 bg-[#008556] text-white rounded-xl items-center gap-2"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 2.5C16.5967 2.5 17.169 2.73705 17.591 3.15901C18.0129 3.58097 18.25 4.15326 18.25 4.75V6.25H16.75V15.25C16.75 15.8467 16.5129 16.419 16.091 16.841C15.669 17.2629 15.0967 17.5 14.5 17.5H4C3.40326 17.5 2.83097 17.2629 2.40901 16.841C1.98705 16.419 1.75 15.8467 1.75 15.25V13.75H13.75V15.25C13.75 15.4337 13.8175 15.611 13.9395 15.7483C14.0616 15.8856 14.2298 15.9733 14.4122 15.9948L14.5 16C14.6837 16 14.861 15.9325 14.9983 15.8105C15.1356 15.6884 15.2233 15.5202 15.2448 15.3378L15.25 15.25V4H5.5C5.3163 4.00002 5.139 4.06747 5.00172 4.18954C4.86444 4.31161 4.77674 4.47981 4.75525 4.66225L4.75 4.75V12.25H3.25V4.75C3.25 4.15326 3.48705 3.58097 3.90901 3.15901C4.33097 2.73705 4.90326 2.5 5.5 2.5H16Z"
                  fill="white"
                />
              </svg>
              View Contract
            </button>
          </div>

          <div className=" pt-1 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6 ">
              <div className="lg:col-span-1 border-r">
                <div>
                  <label className="inter-font2">SCFHS License Number</label>
                  <div className="text-[#0A0D14] inter-font">
                    {contractDetails?.physician?.licenseNumber}
                  </div>
                </div>
              </div>
              <div className="lg:col-span-1 border-r">
                <div className="flex flex-col items-center justify-center">
                  <div>
                    <label className="inter-font2">
                      SCFHS License Expiry Date
                    </label>
                    <div className="text-[#DF1C41] inter-font">
                      {contractDetails?.physician?.licenseExpiryDate}
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-1"></div>
            </div>
          </div>
          <div className="bg-[#E2E4E9] h-[72px] flex items-center">
            <div className="pl-4 flex items-center space-x-1 ">
              <div className=" ">
                <img src={user1} alt="License Icon" className="w-6 h-6" />
              </div>
              <h3 className="label-medium pt-2">Practitioner Information</h3>
            </div>
          </div>

          <div className="pt-1 ml-4">
            {/* First Row: Two Columns */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-6 pb-6">
              <div className="lg:col-span-1 border-r">
                <label className="inter-font2">Arabic Name</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.firstArabicName}
                </div>
              </div>
              <div className="lg:col-span-1">
                <label className="inter-font2">English Name</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.user?.firstName}
                </div>
              </div>
            </div>
            <hr />

            {/* Third Row: Three Columns */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
              <div className="lg:col-span-1 border-r">
                <label className="inter-font2">Nationality</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.nationality}
                </div>
              </div>
              <div className="lg:col-span-1 border-r">
                <label className="inter-font2">Identity #</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.identityNumber}
                </div>
              </div>
              <div className="lg:col-span-1"></div>
            </div>
            <hr />

            {/* Fourth Row: Three Columns */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
              <div className="lg:col-span-1 border-r">
                <label className="inter-font2">Date of Birth</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.dateOfBirth}
                </div>
              </div>
              <div className="lg:col-span-1 border-r">
                <label className="inter-font2">Place Of Birth</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.placeOfBirth}
                </div>
              </div>
              <div className="lg:col-span-1">
                <label className="inter-font2">Gender</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.gender}
                </div>
              </div>
            </div>
            <hr />
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
              <div className="lg:col-span-1 border-r">
                <label className="inter-font2">Email</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.user?.email}
                </div>
              </div>
              <div className="lg:col-span-1 border-r">
                <label className="inter-font2">Phone Number</label>
                <div className="text-[#0A0D14] inter-font">
                  {contractDetails?.physician?.user?.phoneNumber}
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#E2E4E9] h-[72px] flex items-center">
            <div className="flex items-center space-x-1 ">
              <div className="pl-4">
                <img src={stetho} alt="License Icon" className="w-6 h-6" />
              </div>

              <h3 className="label-medium pt-2">Personal Information</h3>
            </div>
          </div>

          <div className=" pt-1 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
              <div className="lg:col-span-1 border-r">
                <div>
                  <label className="inter-font2">Practitioner Type</label>
                  <div className="text-[#0A0D14] inter-font">
                    {contractDetails?.physician?.practitionerType}
                  </div>
                </div>
              </div>
              <div className="lg:col-span-1">
                <div>
                  <label className="inter-font2">Practitioner Level</label>
                  <div className="text-[#0A0D14] inter-font">
                    {contractDetails?.physician?.practitionerLevels}
                  </div>
                </div>
              </div>
              <div className="lg:col-span-1">
                <div></div>
              </div>
            </div>
          </div>

          <div className="bg-[#E2E4E9] h-[72px] flex items-center">
            <div className="flex items-center space-x-1 ">
              <div className="pl-4">
                <img src={first} alt="License Icon" className="w-6 h-6 " />
              </div>
              <h3 className="label-medium pt-2">Medical Specialties</h3>
            </div>
          </div>

          <div className=" pt-1 ml-4 ">
            <div className="flex gap-4 pt-7 pb-7">
              {contractDetails?.physician?.related_medical_specialties?.map(
                (label, index) => (
                  <span
                    key={index}
                    className="cursor-pointer leading-[16px] text-[12px] text-xs font-medium px-2.5 py-0.5 rounded border h-[24px] bg-[#2D9F75] text-[#fff] border-[#E2E4E9]"
                  >
                    {label?.name}
                  </span>
                )
              )}
            </div>
          </div>

          <div className="bg-[#E2E4E9] h-[72px] flex items-center">
            <div className="flex items-center space-x-1 ">
              <div className="pl-4">
                <img src={briefcase2} alt="License Icon" className="w-6 h-6" />
              </div>

              <h3 className="label-medium pt-2">Job Information</h3>
            </div>
          </div>

          <div className=" pt-1 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
              <div className="lg:col-span-1 border-r">
                <div>
                  <label className="inter-font2">
                    Current Job Organisation
                  </label>
                  <div className="text-[#0A0D14]">
                    {contractDetails?.physician?.currentJobOrganization}
                  </div>
                </div>
              </div>
              <div className="lg:col-span-1">
                <div>
                  <label className="inter-font2">Current Job Title</label>
                  <div className="text-[#0A0D14]">
                    {contractDetails?.physician?.currentJobTitle}
                  </div>
                </div>
              </div>

              <div className="lg:col-span-1">
                <div>
                  <label className="inter-font2">Hospital Preference</label>
                  <div className="text-[#0A0D14]">
                    {contractDetails?.physician?.sites?.map((file) => {
                      return (
                        <div
                          key={file.value} // Use a unique key, assuming `file.value` is unique
                          className="bg-[#F0F4F8] p-2 mb-2 rounded-md w-[185px] truncate"
                          title={file.label}
                        >
                          {file?.name}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="lg:col-span-1">
                <div>
                  <label className="inter-font2">Hospital Preference</label>
                  <div className="text-[#0A0D14]">
                    {contractDetails?.physician?.siteIds?.map((file) => {
                      return (
                        <div
                          key={file.value} // Use a unique key, assuming `file.value` is unique
                          className="bg-[#F0F4F8] p-2 mb-2 rounded-md w-[185px] truncate"
                          title={file.label}
                        >
                          {file.label}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#E2E4E9] h-[72px] flex items-center">
            <div className="flex items-center space-x-1 ">
              <div className="pl-4">
                <img src={graduation} alt="License Icon" className="w-6 h-6" />
              </div>
              <h3 className="label-medium pt-2">Education Documents</h3>
            </div>
          </div>

          <div className=" pt-1 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
              {contractDetails?.physician?.educationDocument?.map((file) => {
                const filePath = file?.path || file;
                const fileExtension = filePath
                  ?.split?.('.')
                  ?.pop()
                  ?.toLowerCase(); // Get the file extension

                let fileIcon = null;

                // Check file type and assign the appropriate icon
                if (fileExtension === 'pdf') {
                  fileIcon = pdfIcon; // Set PDF icon
                } else if (
                  fileExtension === 'doc' ||
                  fileExtension === 'docx'
                ) {
                  fileIcon = docIcon; // Set DOC icon
                }
                return (
                  <div
                    key={file.path}
                    className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                  >
                    {fileIcon && (
                      <img
                        src={fileIcon}
                        alt="file icon"
                        className="w-[40px] h-[40px] flex-shrink-0"
                      />
                    )}

                    <div className="flex flex-col w-full">
                      <div className="flex justify-between items-center w-full">
                        <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                          {filePath}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="bg-[#E2E4E9] h-[72px] flex items-center">
            <div className="flex items-center space-x-1 ">
              <div className="pl-4">
                <img src={suitcase} alt="License Icon" className="w-6 h-6 " />
              </div>

              <h3 className="label-medium pt-2">Experience Documents</h3>
            </div>
          </div>

          <div className=" pt-1 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
              {contractDetails?.physician?.experienceDocument?.map((file) => {
                const filePath = file?.path || file;
                const fileExtension = filePath
                  ?.split?.('.')
                  ?.pop()
                  ?.toLowerCase(); // Get the file extension

                let fileIcon = null;

                // Check file type and assign the appropriate icon
                if (fileExtension === 'pdf') {
                  fileIcon = pdfIcon; // Set PDF icon
                } else if (
                  fileExtension === 'doc' ||
                  fileExtension === 'docx'
                ) {
                  fileIcon = docIcon; // Set DOC icon
                }
                return (
                  <div
                    key={file.path}
                    className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                  >
                    {fileIcon && (
                      <img
                        src={fileIcon}
                        alt="file icon"
                        className="w-[40px] h-[40px] flex-shrink-0"
                      />
                    )}

                    <div className="flex flex-col w-full">
                      <div className="flex justify-between items-center w-full">
                        <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                          {filePath}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="bg-[#E2E4E9] h-[72px] flex items-center">
            <div className="flex items-center space-x-1 ">
              <div className="pl-4">
                <img src={firstKit} alt="License Icon" className="w-6 h-6" />
              </div>
              <h3 className="label-medium pt-2">
                Practitioner Specialties Documents
              </h3>
            </div>
          </div>

          <div className=" pt-1 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
              {contractDetails?.physician?.practitionerSpecialtiesDocuments?.map(
                (file) => {
                  const filePath = file?.path || file;
                  const fileExtension = filePath
                    ?.split?.('.')
                    ?.pop()
                    ?.toLowerCase(); // Get the file extension

                  let fileIcon = null;

                  // Check file type and assign the appropriate icon
                  if (fileExtension === 'pdf') {
                    fileIcon = pdfIcon; // Set PDF icon
                  } else if (
                    fileExtension === 'doc' ||
                    fileExtension === 'docx'
                  ) {
                    fileIcon = docIcon; // Set DOC icon
                  }
                  return (
                    <div
                      key={file.path}
                      className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                    >
                      {fileIcon && (
                        <img
                          src={fileIcon}
                          alt="file icon"
                          className="w-[40px] h-[40px] flex-shrink-0"
                        />
                      )}

                      <div className="flex flex-col w-full">
                        <div className="flex justify-between items-center w-full">
                          <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                            {filePath}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </div>

          {contractDetails?.physician?.requestAttachments.length > 0 && (
            <>
              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="flex items-center space-x-1 ">
                  <div className="pl-4">
                    <img src={arrowgo} alt="License Icon" className="w-6 h-6" />
                  </div>
                  <h3 className="label-medium pt-2">Additional Attachments</h3>
                </div>
              </div>

              <div className=" pt-1 ml-4 ">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  {contractDetails?.physician?.requestAttachments?.map(
                    (file) => {
                      const filePath = file?.path || file;
                      const fileExtension = filePath
                        ?.split?.('.')
                        ?.pop()
                        ?.toLowerCase(); // Get the file extension

                      let fileIcon = null;

                      // Check file type and assign the appropriate icon
                      if (fileExtension === 'pdf') {
                        fileIcon = pdfIcon; // Set PDF icon
                      } else if (
                        fileExtension === 'doc' ||
                        fileExtension === 'docx'
                      ) {
                        fileIcon = docIcon; // Set DOC icon
                      }
                      return (
                        <div
                          key={file.path}
                          className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                        >
                          {fileIcon && (
                            <img
                              src={fileIcon}
                              alt="file icon"
                              className="w-[40px] h-[40px] flex-shrink-0"
                            />
                          )}

                          <div className="flex flex-col w-full">
                            <div className="flex justify-between items-center w-full">
                              <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                {filePath}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default HospitalContractDetail;
